/** Script to add link URLs for custom additional swatches 
  This script dynamically assigns URLs to custom additional swatch links (elements with
  class "u2c_customized-swatch") using product data provided by the UP_TO_CODE_DATA
  global variable. Each link's URL will point to the relevant product/variant page.
  */

async function run() {
  // Extract product data by product name from the global data object
  const { byProductName } = window.UP_TO_CODE_DATA;

  /** Assign link URLs to custom additional swatch links */
  function assignCustomSwatchLinkURL(link) {
    // Early return for links that already have a href attribute
    const linkHref = link.getAttribute("href");
    if (linkHref && linkHref !== "") {
      return;
    }

    // Get color value and formatted product title from data attributes
    const colorValue = link.dataset.colorValue;
    const formattedProductTitle = link.dataset.formattedProductTitle;
    // Lookup product data using product title
    const productData = byProductName[formattedProductTitle];

    if (productData) {
      // Find product details for this specific swatch color
      const productDetails = productData.find(
        (item) => item.color === colorValue
      );
      if (productDetails) {
        // Construct product URL using handle and variant ID
        const linkURL = `${window.location.origin}/products/${productDetails.handle}?variant=${productDetails.variantId}`;

        // Set the link's href attribute to the correct URL
        link.href = linkURL;
      }
    }
  }

  // Find all custom additional swatch button elements (PDP)
  const customAdditionalSwatchButtons = document.querySelectorAll(
    ".u2c_customized-swatch-button"
  );

  // Assign link URLs to custom additional swatch buttons
  customAdditionalSwatchButtons.forEach(assignCustomSwatchLinkURL);
}

// Preferred: use theme's custom event (fires when modal content is injected and "empty" is removed)
document.addEventListener("quickview:loaded", run, { once: true });
// Fallback: observe for "empty" class removal if custom events are disabled
const modal = document.querySelector("[data-quick-view-modal]");
if (modal) {
  const content = modal.querySelector(".quick-view-modal__content");
  if (content) {
    if (!content.classList.contains("empty")) {
      run();
    } else {
      const observer = new MutationObserver(() => {
        if (!content.classList.contains("empty")) {
          observer.disconnect();
          run();
        }
      });
      observer.observe(content, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }
}
